<template>
    <loader_page
        v-if="isLoadPage"
        :key="'load_page'"
    />

    <div v-else class="login_page__container">
        <div class="login_page__wrapper">
            <a class="login_page__logo" :href="urlHome">
                <img src="/images/getorder_logo.svg">
            </a>

            <div class="login_page__login_input">
                <input type="text" class="login_input" v-model="user_send.username" placeholder="Login">
                <div class="login_page__login_input_icon_error" :class="classShowError"></div>
            </div>
            <div class="login_page__password_input">
                <input type="password" class="password_input" v-model="user_send.password" placeholder="Password">
                <div class="login_page__password_input_icon_error" :class="classShowError"></div>
            </div>

            <div class="login_page__error_text" :class="classShowError">
                {{ __t('O.LOGIN_OR_PASSWORD_WAS_ENTERED_INCORRECTLY') }} <br>
                {{ __t('O.MAKE_SURE_YOU_ENTERED_THE_DATA_CORRECTLY') }}
            </div>

            <button class="login_page__login_button" :class="classLoginButton" @click.prevent="make_auth">
                <spinner_button
                    v-if="isLoginUser"
                    :key="'spinner_button_login'"
                    :size="'20px'"
                    :color="colorSpinner"
                />

                <div v-if="!isLoginUser" class="login_page__login_button_text" :class="classTextButton">
                    {{ __t('O.SIGN_IN') }}
                </div>
            </button>

            <button :disabled="can_login" class="login_page__registration_button">
                <div class="login_page__registration_button_text">
                    {{ __t('O.REGISTRATION') }}
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import loader_page from '../loader/LoaderPage.vue';
import {createHelpers} from 'vuex-map-fields';
import {getFullUrl} from "../../helpers/urlFunctions";
import spinner_button from "../loader/SpinnerButton.vue";
import {colorFunctions} from "../../mixins/colorFunctions";
import __t from "../../mixins/translate";
import {errorOutput} from "../../helpers/errorOutput";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
export default {
    name: "auth_page",
    components: {
        loader_page,
        spinner_button,
    },
    mixins: [colorFunctions],
    data() {
        return {
            user_send: {
                'username': "",
                "password": "",
            },
            loginError: false,
            isLoginUser: false,
        }
    },
    methods: {
        async make_auth() {
            this.$store.dispatch('user/STATE_LOAD_PAGE', true);
            this.loginError = false;

            if (this.can_login) {
                await $api.post('/login_remote_server', this.user_send)
                    .then(({data}) => {
                        if (data.status === "operation_success") {
                            if (data.data.hasOwnProperty("redirect")) {
                                console.log(data.data.redirect)
                                window.location.href = data.data.redirect;
                            } else {
                                window.location.reload();
                            }
                        } else {
                            this.loginError = true;
                            errorOutput(__t('O.ERROR_AUTH'));
                        }
                    }).catch((error) => {
                        this.loginError = true;
                        if (error.hasOwnProperty("response")) {
                            let resp = error.response.data;
                            errorOutput('Authorization error', resp.message);
                        } else {
                            errorOutput('Authorization error');
                        }
                        this.$store.dispatch('user/STATE_LOAD_PAGE', false);
                    })
            }
        },
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
            'isAuthUser',
            'isLoadPage',
        ]),

        can_login() {
            return this.user_send.username.length > 2 && this.user_send.password.length > 2;
        },

        classLoginButton() {
            let classButton = {'active': false, 'show_error': false};

            if (this.can_login) {
                classButton['active'] = true;
            }

            if (this.loginError) {
                classButton['show_error'] = true;
            }

            return classButton;
        },

        classTextButton() {
            if (this.can_login) {
                return {'active': true};
            }
            return {'active': false};
        },

        classShowError() {
            if (this.loginError) {
                return {'show': true};
            }
            return {'show': false};
        },

        urlHome() {
            return getFullUrl('/');
        },

        colorSpinner() {
            return this.darkerColorHex('#F6673C', 10);
        },
    },
}
</script>
